module.exports = __webpack_public_path__ + "img/supplier_legalRepresentative.11aec6e6.png";